import React, { useMemo } from "react"

import { COLORS, roundNumber } from "../../../utils"

import { getPSEStepComponentIngredientsData } from "../../../utils/stepComponentUtils"
import PSESection from "./section/PSESection"
import { PSE_BLOCK_TYPES } from "../../../utils/productionStepExecution"
import { TableCell, TableHead, TableRow, Table } from "@mui/material"
import { StyledTableBody } from "./section/StyledSections"

const sx = {
	tableHead: {
		color: "#262626",
		fontSize: 14,
		fontWeight: 500,
		lineHeight: "22px",
		borderBottom: "none"
	},
	tableCell: {
		fontSize: 16,
		fontWeight: 400,
		lineHeight: "24px",
		border: "none"
	},
	gapCell: {
		color: COLORS.GREY_BACK_BUTTON,
		fontSize: 20,
		fontStyle: "normal",
		fontWeight: 400,
		lineHeight: 0.8,
	},
	weightLabel: {
		color: "#7C7C7C"
	}
}

const PSEStepComponents = ({
	stepComponents,
	expectedProduction = 0,
	coeff = 1,
	substitutes,
	productionStepExecution,
	priorStepData
}) => {
	const data = useMemo(() => {
		const newStepComponents = getPSEStepComponentIngredientsData({
			stepComponents,
			substituteSupplierItems: substitutes,
			expectedProduction,
			coeff,
			productionStepExecution,
			priorStepData
		})

		return newStepComponents
	}, [stepComponents, substitutes, expectedProduction, coeff, productionStepExecution])

	return (
		<PSESection
			productionStepExecution={productionStepExecution}
			sectionType={PSE_BLOCK_TYPES.INGREDIENTS}
			title="Ingrédients"
			spacing={0}
		>
			<Table sx={{ minWidth: 650 }} aria-label="pse table">
				<TableHead>
					<TableRow>
						<TableCell sx={{ ...sx.tableCell, width: "51.1%" }}></TableCell>
						<TableCell sx={{ ...sx.tableCell, width: "19.6%", color: COLORS.BLACK_600 }}>Poids en entrée</TableCell>
						<TableCell sx={{ ...sx.tableCell, width: "29.3%", color: COLORS.BLACK_600 }}>Écart au poids théorique</TableCell>
					</TableRow>
				</TableHead>
				<StyledTableBody>
					{data.map((stepComponent, index) => {
						const { name, weight, supplierItemPieceUnitWeight, gap } = stepComponent
						return (
							<TableRow
								key={stepComponent.index + index}
								sx={{ height: 49 }}
							>
								<TableCell sx={{
									...sx.tableCell,
									borderTopLeftRadius: "8px",
									borderBottomLeftRadius: "8px",
									width: "48%"
								}}>
									{name}
								</TableCell>
								<TableCell sx={{ ...sx.tableCell }}>
									<span>{roundNumber(weight, 2)}</span>
									<span style={sx.weightLabel}> kg</span>
									{supplierItemPieceUnitWeight ? ` = ${(roundNumber(supplierItemPieceUnitWeight, 2) * productionStepExecution.expectedProduction).toString().replace(".", ",")} ${roundNumber(supplierItemPieceUnitWeight, 2) > 1 ? "pièces" : "pièce"}` : ""}
								</TableCell>
								<TableCell sx={{ ...sx.tableCell, borderTopRightRadius: "8px", borderBottomRightRadius: "8px" }}>
									<span>{
										gap > 0 ? "+" + gap :
											gap < 0 ? gap :
												"-"
									}
									</span>
									<span style={sx.weightLabel}>
										{gap ? " kg" : ""}
									</span>
								</TableCell>
							</TableRow>
						)
					})}
				</StyledTableBody>
			</Table>
		</PSESection>
	)
}

export default PSEStepComponents